export const runningIndexList = (activities) => {
    
    activities = Array.from(activities)
    activities = activities.filter(activity => activity.counts === true)
    const runningIndex = activities.map(activity =>activity.runningIndex.toFixed(2))
    const dates = activities.map(activity =>activity.date)
    //console.log(runningIndex,"lookhere")
    if (runningIndex.length===0){
      //console.log(activities,"is null?")
      return [[0,0],["1","2"]]
      
    }

    return [runningIndex,dates]
}

export const runningIndexMedian = (activities) => {
  console.time("Old");
    if (typeof(activities) === "undefined"){
        return [0,0]
    }
    activities = Array.from(activities)
    var maxMedian = 0
    var maxIndex = 0
    var minMedian =100
    var minIndex = 0
    if (activities.length>3){
      activities = activities.filter(activity => activity.counts === true)
      
      var runningIndexMedianList = []
      const lenList = activities.length
      for (var i=0;i<lenList;i++){
        var median = 0
        //var weight = 10
        if (i>10){
          for (var j=0;j<10;j++){
            median = median + activities[i-j].runningIndex
          }
          median = median/10
          if (median>maxMedian){
            maxMedian = median.toFixed(2)
            maxIndex = i
          }
          if (median<minMedian){
            minMedian = median.toFixed(2)
            minIndex = i
          }
          runningIndexMedianList.push(median.toFixed(2))
        }
        else{
          for (j=0;j<i;j++){
            median = median +activities[i-j].runningIndex
          }
          median = median/i
          if (median>maxMedian){
            maxMedian = median.toFixed(2)
            maxIndex = i
          }
          if (median<minMedian){
            minMedian = median.toFixed(2)
            minIndex = i
          }
          runningIndexMedianList.push(median.toFixed(2))
        }
        
        
      }

    }
    if (!runningIndexMedianList){
      //console.log(activities,"is null 2?")
      return [[0,0],["1","2"]]
    }
    console.timeEnd("Old");
    return [runningIndexMedianList,maxMedian,maxIndex,minMedian,minIndex]
}

/// i will erase this function
export const runningIndexMedian2 = (activities) => {
  console.time("New");
  if (typeof(activities) === "undefined"){
      return [0,0]
  }
  activities = Array.from(activities)
  var maxMedian = 0
  var maxIndex = 0
  var minMedian =100
  var minIndex = 0
  if (activities.length>3){
    activities = activities.filter(activity => activity.counts === true)
    
    var runningIndexMedianList = []
    const lenList = activities.length
    for (var i=0;i<lenList;i++){
      var median = 0
      //var weight = 10
      
      if (i>10){
        median = runningIndexMedianList[i-1]*10 + activities[i].runningIndex - activities[i-10].runningIndex
        median = median/10
        //console.log(median,i)
        if (median>maxMedian){
          maxMedian = median.toFixed(2)
          maxIndex = i
        }
        if (median<minMedian){
          minMedian = median.toFixed(2)
          minIndex = i
        }
        runningIndexMedianList.push(median.toFixed(2))
      }
      else{
        for (var j=0;j<i;j++){
          median = median +activities[i-j].runningIndex
        }
        median = median/i
        if (median>maxMedian){
          maxMedian = median.toFixed(2)
          maxIndex = i
        }
        if (median<minMedian){
          minMedian = median.toFixed(2)
          minIndex = i
        }
        runningIndexMedianList.push(median.toFixed(2))
      }
      
      
    }

  }
  if (!runningIndexMedianList){
    //console.log(activities,"is null 2?")
    return [[0,0],["1","2"]]
  }
  console.timeEnd("New");
  return [runningIndexMedianList,maxMedian,maxIndex,minMedian,minIndex]
}

export function calcRunningIndex(entry){
  var max_hr = localStorage.getItem('max_hr')
  var x = entry.hr/max_hr*1.45-0.30
  var distance = Number(entry.distance)
  var up = Number(entry.up)
  //var down = Number(entry.down)
  var d = distance + 3*up //d = distance + 6*up //- 4*down changed due to strava not provide down
  var RIO = (213.9/entry.duration) * Math.pow(d/1000,1.06) +3.5
  var runningIndex = RIO/x

  return runningIndex.toFixed(2)
}
     
export function calcTrimpTss(entry){

     var rest_hr = localStorage.getItem("rest_hr")
     var max_hr = localStorage.getItem("max_hr")
     var lactate_th = localStorage.getItem("lactate_th")
     //calculate trimp and tss
     var hrr = (entry.hr-rest_hr)/(max_hr-rest_hr)
     var trimp=0
     Math.round(entry.duration)
     for (var i=0;i<entry.duration;i++){
         trimp = trimp + 1 * hrr * 0.64 * Math.exp(1.92 * hrr)
     }
     
     var hr_lthr = (lactate_th - rest_hr)/(max_hr - rest_hr)
     var hour_lthr = 60 * hr_lthr * 0.64 * Math.exp(1.92 * hr_lthr)
     var tss =  (trimp/hour_lthr)*100

     return [trimp,tss.toFixed(2)]

}    


export function runningIndexFeedback(runningIndex){
  if (runningIndex < 30){
    return ['text-danger','poor']
  }
  if (runningIndex < 38){
    return ['text-warning','fair']
  }
  if (runningIndex < 45){
    return ['text-info','good']
  }
  if (runningIndex < 55){
    return ['text-success','very good']
  }
  if (runningIndex < 65){
    return ['text-white','excellent']
  }
  else{
    return ['text-primary','superior']
  }
}



export function distanceReadiness(weeklymilage,distance){
  var readiness = weeklymilage[weeklymilage.length-1] + weeklymilage[weeklymilage.length-2] *0.6 + weeklymilage[weeklymilage.length-3]*0.5 + weeklymilage[weeklymilage.length-4]*0.4 + weeklymilage[weeklymilage.length-5]*0.2 + weeklymilage[weeklymilage.length-6]*0.1 + weeklymilage[weeklymilage.length-7]*0.05+ weeklymilage[weeklymilage.length-8]*0.03
  //console.log("diidi",weeklymilage,distance)
  readiness = readiness/2880  // 2.5 * 1000 ( cause it is in meters)
  //console.log(readiness)
  
  if (distance===42){
      readiness = readiness*1.7
  }
  if (distance===21){
      readiness = readiness*2.9
  }
  if (distance===10){
      readiness = readiness*3.7
  }
  if (distance===5){
      readiness = readiness*7
  }
  
  if (readiness>100){
      readiness = 100
  }
  //console.log(readiness,distance)
  return readiness
}


export function distancePredictCalculate(runningIndex,restHr){
  console.log(runningIndex,restHr)
  var restHrFactor = (60 - restHr)*0.003

  var d = 5000
  var x = (0.955-restHrFactor)*1.45-0.30
  var duration = (Math.pow(d/1000,1.06)*213.9)/(runningIndex*x-3.5)
  if (duration<0){
    duration = 0
  }
  d = 10000
  x = (0.925-restHrFactor)*1.45-0.30
  var duration10k = (Math.pow(d/1000,1.06)*213.9)/(runningIndex*x-3.5)
  if (duration10k<0){
    duration10k = 0
  }
  d = 21000
  x = (0.87-restHrFactor)*1.45-0.30
  var duration21k = (Math.pow(d/1000,1.06)*213.9)/(runningIndex*x-3.5)
  if (duration21k<0){
    duration21k = 0
  }
  d = 42000
  x = (0.84-restHrFactor)*1.45-0.30
  var duration42k = (Math.pow(d/1000,1.06)*213.9)/(runningIndex*x-3.5)
  if (duration42k<0){
    duration42k = 0
  }
  return[timeConvert(duration),timeConvert(duration10k),timeConvert(duration21k),timeConvert(duration42k)]
  
}


export function timeConvert(time) {
  var hours = Math.floor(time/60)
  var min = Math.floor(time-hours*60)
  var sec = time % 60-Math.floor(time-hours*60)
  //console.log(sec)
  sec = sec*60
  sec = sec.toFixed(0)
  if (sec<10){
      sec = `0${sec}`
  }
  if (min<10){
    min = `0${min}`
  }
  return (hours+':'+min+':'+sec);
}



  
      
      
 


export function month(date){
  date = date.split(" ")
  return date[2]+" "+date[3]
}
